import { DOCUMENT, Injectable, inject } from '@angular/core';
import { TUI_IS_MOBILE } from '@taiga-ui/cdk';

// Пока открыт список tuiDropdownMobile, на body висит этот класс (addon-mobile Taiga)
export const DROPDOWN_MOBILE_CLASS = 't-dropdown-mobile';

// Касание дольше этого — уже не тап, click от него не гасим
const TAP_TIMEOUT_MS = 800;

// Гасит «призрачный» click после закрытия tuiDropdownMobile. Список закрывается уже на
// касании (шеврон, тап мимо), поле возвращается на место в форме, и click от того же
// касания приходит в то, что оказалось под пальцем, — например, в крестик SidePage.
// Выбор пункта не затрагивается: список закрывается в обработчике click, позже этой проверки
@Injectable({ providedIn: 'root' })
export class MobileDropdownGhostClickService {
  private readonly doc = inject(DOCUMENT);

  // Время касания, начатого при открытом списке
  private openedTapAt = 0;

  constructor() {
    const win = this.doc.defaultView;
    if (!inject(TUI_IS_MOBILE) || !win) return;

    // window и capture — раньше обработчиков Taiga на document
    win.addEventListener('pointerdown', () => this.onPointerDown(), true);
    win.addEventListener('click', (event) => this.onClick(event), true);
  }

  private onPointerDown(): void {
    this.openedTapAt = this.isOpen() ? Date.now() : 0;
  }

  private onClick(event: MouseEvent): void {
    const isGhost =
      this.openedTapAt && !this.isOpen() && Date.now() - this.openedTapAt < TAP_TIMEOUT_MS;

    this.openedTapAt = 0;

    if (isGhost) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  private isOpen(): boolean {
    return this.doc.body.classList.contains(DROPDOWN_MOBILE_CLASS);
  }
}
